{
    "general": {
        "back": "Retour",
        "close": "Fermer",
        "cancel": "Annuler",
        "ok": "Ok",
        "next": "Suivant",
        "optional": "facultatif",
        "toast": {
            "error": "Erreur",
            "unknownError": "Erreur inconnue"
        },
        "languages": {
            "en": "English",
            "fr": "Français"
        }
    },
    "forms": {
        "errors": {
            "required": "{{field}} est requis.",
            "email": "{{field}} n'est pas une adresse e-mail valide.",
            "minlength": "{{field}} doit contenir au moins {{requiredLength}} caractères.",
            "maxlength": "{{field}} ne peut pas dépasser {{requiredLength}} caractères.",
            "min": "{{field}} doit être au moins {{min}}.",
            "max": "{{field}} ne peut pas dépasser {{max}}.",
            "pattern": "{{field}} a un format invalide.",
            "invalid": "{{field}} est invalide.",
            "minSelected": "Veuillez en sélectionner au moins {{required}}."
        }
    },
    "shared": {
        "grid": {
            "loading": "Chargement...",
            "pageReport": "Affichage de {first} à {last} sur {totalRecords}",
            "locale": {
                "loadingOoo": "Chargement...",
                "loadingError": "Erreur",
                "noRowsToShow": "Aucune ligne à afficher",
                "empty": "Choisir une option",
                "blanks": "(Vides)",
                "true": "Vrai",
                "false": "Faux",
                "contains": "Contient",
                "notContains": "Ne contient pas",
                "equals": "Égal à",
                "notEqual": "Différent de",
                "startsWith": "Commence par",
                "endsWith": "Termine par",
                "lessThan": "Inférieur à",
                "greaterThan": "Supérieur à",
                "lessThanOrEqual": "Inférieur ou égal à",
                "greaterThanOrEqual": "Supérieur ou égal à",
                "inRange": "Entre",
                "inRangeStart": "De",
                "inRangeEnd": "À",
                "blank": "Vide",
                "notBlank": "Non vide",
                "before": "Avant",
                "after": "Après",
                "filterOoo": "Filtrer...",
                "searchOoo": "Rechercher...",
                "applyFilter": "Appliquer",
                "resetFilter": "Réinitialiser",
                "clearFilter": "Effacer",
                "cancelFilter": "Annuler",
                "selectAll": "(Tout sélectionner)",
                "selectAllSearchResults": "(Tout sélectionner dans les résultats)",
                "noMatches": "Aucun résultat",
                "andCondition": "ET",
                "orCondition": "OU",
                "sortAscending": "Tri croissant",
                "sortDescending": "Tri décroissant",
                "sortUnSort": "Annuler le tri",
                "pinColumn": "Épingler la colonne",
                "pinLeft": "Épingler à gauche",
                "pinRight": "Épingler à droite",
                "noPin": "Ne pas épingler",
                "autosizeThiscolumn": "Ajuster cette colonne",
                "autosizeAllColumns": "Ajuster toutes les colonnes",
                "resetColumns": "Réinitialiser les colonnes",
                "expandAll": "Tout développer",
                "collapseAll": "Tout réduire"
            }
        }
    },
    "login": {
        "left": {
            "tagline": "Fournisseur de confiance",
            "endToEndEncrypted": "Chiffré de bout en bout",
            "zeroKnowledge": "Architecture à divulgation nulle de connaissance"
        },
        "email": {
            "title": "Bon retour",
            "subtitle": "Veuillez saisir votre adresse e-mail pour continuer.",
            "emailLabel": "Adresse e-mail professionnelle",
            "emailPlaceholder": "nom@precision.com",
            "requestCode": "Demander un code de connexion",
            "errors": {
                "invalidEmail": "Adresse e-mail invalide"
            }
        },
        "otp": {
            "title": "Vérifiez votre e-mail",
            "subtitle": "Veuillez saisir le code d'accès à 6 chiffres envoyé à votre adresse e-mail.",
            "verifyAndLogin": "Vérifier et se connecter",
            "errors": {
                "invalidCode": "Code invalide"
            }
        }
    },
    "header": {
        "userMenu": {
            "settings": "Paramètres",
            "darkMode": "Mode sombre",
            "logOut": "Se déconnecter"
        }
    },
    "pageTitles": {
        "home": "Tableau de bord",
        "workPackages": {
            "list": "Lots de travail",
            "create": "Créer un lot de travail",
            "dashboard": "Tableau de bord"
        },
        "clients": {
            "list": "Clients",
            "create": "Nouveau client",
            "dashboard": "Tableau de bord"
        },
        "deviceApprovals": "Approbations d'appareils"
    },
    "sidebar": {
        "pages": {
            "workPackages": "Lots de travail",
            "clients": "Clients",
            "deviceApprovals": "Approbations d'appareils"
        },
        "statusCard": {
            "title": "État du système",
            "statuses": {
                "online": "En ligne"
            }
        }
    },
    "features": {
        "workPackages": {
            "general": {
                "workPackageStatus": {
                    "active": "Actif",
                    "inProgress": "En cours",
                    "archived": "Archivé"
                },
                "fields": {
                    "id": "ID du lot de travail",
                    "name": "Nom du lot de travail",
                    "description": "Description du lot de travail",
                    "status": "Statut du lot de travail",
                    "archivedAt": "Archivé le",
                    "createdAt": "Créé le",
                    "createdBy": "Créé par",
                    "lastUpdatedAt": "Mis à jour le",
                    "lastUpdatedBy": "Mis à jour par",
                    "assignedClients": "Clients assignés",
                    "project": "Projet parent",
                    "emptyProjectMessage": "Un nouveau projet sera créé avec ce nom"
                },
                "createNewWorkPackage": "Créer un nouveau lot de travail",
                "updateWorkPackage": "Mettre à jour le lot de travail",
                "workPackageDetails": "Détails du lot de travail"
            },
            "list": {
                "title": "Liste des lots de travail",
                "table": {
                    "headers": {
                        "workPackage": "Lot de travail",
                        "status": "Statut",
                        "assignedClients": "Clients assignés",
                        "createdAt": "Créé le"
                    },
                    "actions": {
                        "edit": {
                            "name": "Modifier",
                            "tooltip": {
                                "allowed": "Modifier",
                                "cannotModifyInProgress": "Les lots de travail en cours ne peuvent pas être modifiés",
                                "cannotModifyArchived": "Les lots de travail archivés ne peuvent pas être modifiés"
                            }
                        },
                        "view": {
                            "name": "Voir les détails",
                            "tooltip": {
                                "allowed": "Voir les détails"
                            }
                        }
                    }
                }
            },
            "closeWorkPackage": {
                "header": {
                    "title": "Fermer le lot de travail ?"
                },
                "body": {
                    "warning": "Cette action fermera et archivera le lot de travail.",
                    "irreversible": "Cette action est irréversible."
                },
                "actions": {
                    "confirm": "Confirmer la fermeture"
                },
                "toast": {
                    "success": "Lot de travail fermé.",
                    "error": "Échec de la fermeture du lot de travail."
                }
            },
            "createWorkPackage": {
                "header": {
                    "title": "Créer un nouveau lot de travail",
                    "subtitle": "Configurez un nouveau lot de travail collaboratif. Un environnement sécurisé sera provisionné."
                },
                "steps": {
                    "workPackageDetails": {
                        "title": "Détails du lot de travail",
                        "placeholders": {
                            "name": "ex. Analyse Urbaine 2024",
                            "description": "Brève description de la portée du lot de travail",
                            "project": "Saisissez pour rechercher un projet"
                        },
                        "assignClients": "Assigner des clients"
                    },
                    "clientAssignment": {
                        "title": "Assignation des clients",
                        "createWorkPackage": "Créer le lot de travail"
                    },
                    "finished": {
                        "title": "Lot de travail créé",
                        "body": "« {{workPackageName}} » est prêt. Les clients assignés pourront y accéder sous peu."
                    }
                }
            },
            "dashboard": {
                "provisioned": "Provisionné",
                "project": "Projet",
                "actions": {
                    "close": "Fermer le lot de travail"
                },
                "metrics": {
                    "totalFiles": "Fichiers totaux",
                    "pendingFiles": "Fichiers en attente",
                    "assignedClients": "Clients assignés",
                    "availability": "Disponibilité",
                    "totalFilesSubmitted": "Total des fichiers soumis",
                    "filesPending": "Fichiers en attente"
                },
                "pipeline": {
                    "title": "État du pipeline",
                    "completedCount": "{{completed}}/{{total}} terminé",
                    "stages": {
                        "schema": "Schéma",
                        "mapping": "Mappage",
                        "encryption": "Chiffr.",
                        "pseudonymization": "Pseudo.",
                        "output": "Sortie"
                    }
                },
                "assignedClients": {
                    "title": "Clients assignés"
                },
                "operations": {
                    "title": "Opérations",
                    "refresh": "Actualiser",
                    "table": {
                        "operationLabel": "Opération",
                        "headers": {
                            "name": "Fichier / Opération",
                            "client": "Client",
                            "fileSize": "Taille",
                            "rowCount": "Lignes",
                            "columnsSelectedCount": "Colonnes",
                            "duration": "Durée",
                            "status": "Statut"
                        },
                        "fileStatus": {
                            "queued": "En attente",
                            "running": "En traitement",
                            "succeeded": "Réussi",
                            "failed": "Échoué"
                        },
                        "operationStatus": {
                            "queued": "En attente",
                            "running": "En traitement",
                            "succeeded": "Réussi",
                            "partialSuccess": "Succès partiel",
                            "failed": "Échoué"
                        }
                    }
                }
            },
            "toast": {
                "updateSuccess": "Lot de travail mis à jour avec succès !"
            }
        },
        "clients": {
            "general": {
                "clientStatus": {
                    "active": "Actif",
                    "inactive": "Inactif",
                    "pending": "En attente"
                },
                "fields": {
                    "id": "ID du client",
                    "name": "Nom du client",
                    "contactPerson": "Personne de contact",
                    "contractNumber": "Numéro de contrat",
                    "status": "Statut du client",
                    "createdAt": "Créé le",
                    "createdBy": "Créé par",
                    "lastUpdatedAt": "Mis à jour le",
                    "lastUpdatedBy": "Mis à jour par",
                    "assignedWorkPackages": "Lots de travail assignés",
                    "entraEnabled": "Connexion Entra ID",
                    "entraTenantId": "ID de l'annuaire (locataire)",
                    "entraAppRegistrationId": "ID d'application (client)"
                },
                "createNewClient": "Ajouter un nouveau client",
                "updateClient": "Mettre à jour le client",
                "clientDetails": "Détails du client",
                "entraStatus": {
                    "enabled": "Activée",
                    "disabled": "Désactivée"
                },
                "errors": {
                    "invalidGuid": "{{field}} doit être un GUID (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)."
                }
            },
            "list": {
                "title": "Liste des clients",
                "countSuffix": "{{count}} enregistrés",
                "searchPlaceholder": "Rechercher des clients...",
                "clearFilters": "Effacer les filtres",
                "table": {
                    "headers": {
                        "clientName": "Client",
                        "contactPerson": "Personne de contact",
                        "contractNumber": "Numéro de contrat",
                        "status": "Statut",
                        "createdAt": "Créé le",
                        "createdBy": "Créé par",
                        "numberOfWorkPackagesAssigned": "Lots de travail assignés"
                    },
                    "actions": {
                        "edit": {
                            "name": "Modifier",
                            "tooltip": {
                                "allowed": "Modifier le client"
                            }
                        },
                        "view": {
                            "name": "Voir les détails",
                            "tooltip": {
                                "allowed": "Voir les détails"
                            }
                        },
                        "regenerateApiKey": {
                            "name": "Régénérer la clé API",
                            "tooltip": {
                                "allowed": "Régénérer la clé API"
                            }
                        },
                        "revokeAccess": {
                            "name": "Révoquer l'accès",
                            "tooltip": {
                                "allowed": "Révoquer l'accès",
                                "cannotRevokeInactive": "Le client n'a aucune clé API"
                            }
                        }
                    }
                }
            },
            "createClient": {
                "header": {
                    "title": "Intégrer un nouveau client",
                    "subtitle": "Enregistrez une nouvelle entité. Cela générera un environnement unique et une clé API de production."
                },
                "steps": {
                    "orgDetails": {
                        "title": "Détails de l'organisation",
                        "placeholders": {
                            "name": "ex. Logistique Mondiale SA",
                            "contactPerson": "ex. Jean Dupont",
                            "contractNumber": "ex. LMS-2026-24551"
                        },
                        "finalizeOnboarding": "Finaliser l'intégration"
                    },
                    "apiKey": {
                        "title": "Intégration réussie",
                        "productionApiKey": "Clé API de production",
                        "apiKeyPlaceholder": "Clé API",
                        "copyApiKey": "Copier la clé API",
                        "copyToastMessage": "Clé API copiée dans le presse-papiers",
                        "warning": "Conservez cette clé en sécurité. Elle ne sera plus affichée, vous devrez la régénérer si elle est perdue."
                    }
                }
            },
            "regenerateApiKey": {
                "header": {
                    "title": "Régénérer la clé API"
                },
                "confirm": {
                    "confirmation": "Êtes-vous sûr de vouloir régénérer la clé API de ce client ?",
                    "warning": "Cette action est irréversible et la clé API actuelle du client sera désactivée.",
                    "regenerate": "Régénérer"
                },
                "result": {
                    "productionApiKey": "Clé API de production",
                    "apiKeyPlaceholder": "Clé API",
                    "copyApiKey": "Copier la clé API",
                    "copyToastMessage": "Clé API copiée dans le presse-papiers",
                    "warning": "Conservez cette clé en sécurité. Elle ne sera plus affichée, vous devrez la régénérer si elle est perdue."
                }
            },
            "revokeApiKey": {
                "header": {
                    "title": "Révoquer la clé API"
                },
                "body": {
                    "confirmation": "Êtes-vous sûr de vouloir révoquer la clé API de ce client ?",
                    "consequence": "Cela empêchera le client d'utiliser l'application jusqu'à ce qu'une nouvelle clé soit régénérée.",
                    "warning": "Cette action est irréversible."
                },
                "actions": {
                    "revoke": "Révoquer l'accès du client"
                },
                "toast": {
                    "success": "La clé API a été révoquée avec succès !",
                    "error": "Échec de la révocation de la clé API !"
                }
            },
            "dashboard": {
                "assignedWorkPackages": {
                    "title": "Lots de travail assignés"
                },
                "noAssignedWorkPackages": {
                    "title": "Aucun lot de travail assigné",
                    "description": "Les lots de travail assignés à ce client apparaîtront ici."
                }
            },
            "detail": {
                "sharingKeys": {
                    "title": "Clés de partage",
                    "empty": "Ce client n'a pas encore enregistré de clés de partage.",
                    "loadError": "Impossible de charger les clés de partage.",
                    "fingerprint": "Empreinte",
                    "registeredAt": "Enregistrée le {{date}}",
                    "disabled": "Désactivée",
                    "encryptionKey": {
                        "label": "Clé de chiffrement"
                    },
                    "revoke": {
                        "button": "Révoquer les clés",
                        "confirmHeader": "Révoquer les clés de partage ?",
                        "confirmBody": "Cela empêchera le client de recevoir des fichiers partagés. Le client devra enregistrer une nouvelle paire de clés sur un appareil pour recevoir à nouveau des partages. Continuer ?",
                        "pendingSharesWarning": "{{count}} partage(s) en attente deviendront non livrables.",
                        "pendingSharesNone": "Aucun partage en attente ne sera affecté.",
                        "toastSuccess": "Clés de partage révoquées",
                        "toastError": "Échec de la révocation des clés de partage."
                    }
                },
                "deviceKeys": {
                    "title": "Clés d'appareil",
                    "empty": "Ce client n'a pas encore enregistré d'appareil.",
                    "loadError": "Impossible de charger les clés d'appareil.",
                    "fingerprint": "Empreinte",
                    "enrolledAt": "Enregistré le {{date}}",
                    "updatedAt": "Mis à jour le {{date}}"
                }
            },
            "toast": {
                "updateSuccess": "Client mis à jour avec succès !"
            }
        },
        "sshKeys": {
            "general": {
                "status": {
                    "pending": "En attente",
                    "active": "Actif",
                    "revoked": "Révoqué",
                    "rejected": "Rejeté"
                }
            },
            "list": {
                "title": "Approbations d'appareils",
                "countSuffix": "{{count}} en attente",
                "empty": {
                    "title": "Aucune approbation d'appareil en attente",
                    "description": "Les demandes d'enregistrement d'appareil apparaîtront ici pour révision."
                },
                "table": {
                    "headers": {
                        "clientName": "Client",
                        "fingerprint": "Empreinte",
                        "createdAt": "Demandé le",
                        "status": "Statut"
                    }
                }
            },
            "actions": {
                "approve": {
                    "tooltip": {
                        "allowed": "Approuver l'appareil",
                        "notPending": "Seules les demandes en attente peuvent être approuvées"
                    },
                    "confirm": {
                        "title": "Approuver l'appareil ?",
                        "body": "Approuver l'appareil ayant l'empreinte {{fingerprint}} pour {{client}}. Le client pourra recevoir des fichiers partagés sur cet appareil."
                    },
                    "toast": {
                        "success": "Appareil approuvé.",
                        "error": "Échec de l'approbation de l'appareil."
                    }
                },
                "reject": {
                    "tooltip": {
                        "allowed": "Rejeter la demande",
                        "notPending": "Seules les demandes en attente peuvent être rejetées"
                    },
                    "confirm": {
                        "title": "Rejeter la demande ?",
                        "body": "Rejeter la demande d'enregistrement de l'appareil ayant l'empreinte {{fingerprint}} pour {{client}}. Le client devra soumettre une nouvelle demande."
                    },
                    "toast": {
                        "success": "Demande rejetée.",
                        "error": "Échec du rejet de la demande."
                    }
                },
                "revoke": {
                    "tooltip": {
                        "allowed": "Révoquer l'accès",
                        "notPending": "Seuls les appareils actifs peuvent être révoqués"
                    },
                    "confirm": {
                        "title": "Révoquer l'accès ?",
                        "body": "Révoquer l'accès de l'appareil ayant l'empreinte {{fingerprint}} appartenant à {{client}}. L'appareil ne pourra plus recevoir de fichiers partagés."
                    },
                    "toast": {
                        "success": "Accès révoqué.",
                        "error": "Échec de la révocation de l'accès."
                    }
                }
            }
        }
    }
}
